import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'bt-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit {
  message: ' ایا اطمینان دارید؟';
  constructor(
    @Inject(MAT_DIALOG_DATA) public data = {
      title: '',
      message: ' ایا اطمینان دارید؟'
    },
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
  ) { }

  ngOnInit() {
  }

}
